export class PersonaContacto {
  contacto: any;
  isAsegurado: boolean;
  newContacto: boolean;
  indiceBeneficiario: any = null;
  contactoSubsecuente: any = null;
  arrayContactos: any = [];
}
